export const PROFILE_SIDEBAR_WIDTH = 80;
